module.exports = __webpack_public_path__ + "img/grid.ec9cdf52.svg";